











































import { Vue, Component } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import { required, email } from 'vuelidate/lib/validators';
import { routeTo } from '@/api/reactor/reactions';

@Component({
  validations: {
    form: {
      newPassword: {
          required
      },
    },
  },
  reactions: {
    '$auth/setAuthenticated': routeTo('login')
  }
})
export default class ChangeTempPassword extends Vue {
  working: boolean = false;
  form: any = {
    newPassword: '',
  };
  errorSnack: boolean = false;
  snackMessage: string = "";

  get newPasswordErrors () {
    const errors: any[] = [];
    if (this.$v && this.$v.form && this.$v.form.newPassword) {
      if (!this.$v.form.newPassword.$dirty) return errors;
      !this.$v.form.newPassword.required && errors.push('New password is required.');
    }
    return errors
  }

  async changePassword () {
     try {
        await this.$store.dispatch('$auth/changeTempPassword', this.form);
      } catch (e) {
        console.log('login exception', e);
        if (e.code && e.code == "NotAuthorizedException") {
          this.snackMessage = e.message;
        } else {
          this.snackMessage = "Unable to sign in";
        }
        this.errorSnack = true;
      }
  }
}
